module.exports = __webpack_public_path__ + "static/img/yz5.687bd10a.png";